import { render, staticRenderFns } from "./FormTres.vue?vue&type=template&id=633b1262&scoped=true&"
import script from "./FormTres.vue?vue&type=script&lang=js&"
export * from "./FormTres.vue?vue&type=script&lang=js&"
import style0 from "./FormTres.vue?vue&type=style&index=0&id=633b1262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b1262",
  null
  
)

export default component.exports